<template>
  <div class="homePage03Box" :style="bg">
    <!-- 头部导航 -->
    <div class="t_bar">
      <!-- 白色logo -->
      <div class="t_placeholder">
        <!-- 白色/蓝色图标 -->
        <div class="t_icon t_icon_search01" @click="$emit('openSearch')"></div>
        <div class="t_menu pointer" @mouseenter="$emit('openMenu')">
          <div class="t_menuitem"></div>
          <div class="t_menuitem t_menuitem2"></div>
          <div class="t_menuitem"></div>
        </div>
      </div>
      <div alt="" class="t_logo t_logo02" />
      <div class="t_right">
        <div class="mN_lage pointer"></div>
        <div class="mN_lag pointer">
          <div class="text">CN</div>
        </div>
      </div>
    </div>
    <div class="content" style="max-width: 1400px">
      <div class="t_text">
        {{ $tools.localStorageFn.get("PAGE_DATE").field.synopsis }}
      </div>
      <div class="b_iconArea">
        <div class="b_iconItem" v-for="item in $tools.localStorageFn.get('PAGE_DATE').field.fieldList" :key="item.id"
          @click="() => {
            $tools.blankPush('/areaExpertiseDetail?id=' + item.id);
          }
            ">
          <div class="b_iconItem_icon">
            <img :src="imgUrl + item.logo" alt="" />
          </div>
          <div class="b_iconItem_label">{{ item.name }}</div>
        </div>
      </div>
      <div class="b_btn" @click="() => {
        $tools.blankPush('/areaExpertise');
      }
        ">
        <div>
          MORE +
          <div class="line"></div>
        </div>
      </div>

      <!-- 底部提示 -->
      <div class="b_right_icon t_icon_backTop" @click="() => {
        $emit('move', 1);
      }
        "></div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      bg: {
        background:
          "url(" +
          this.$tools.localStorageFn.get("PAGE_DATE").banner2 +
          ") no-repeat center center",
      },
    };
  },
  created() {
  },
  methods: {
  },
};
</script>

<style lang="scss">
.homePage03Box {
  height: 100%;
  width: 100%;
  // background: url(~@/assets/images/homeBg03.png) no-repeat center center;
  background-size: cover !important;
  display: flex;
  align-items: center;
  padding: 19.2rem calc((100% - 135rem) / 2) 15rem;
  position: relative;

  .t_bar {
    z-index: 200;
    position: absolute !important;
    top: 6rem;
    left: 0;
    width: 100%;
    padding: 0 8rem;
    display: flex;
    justify-content: space-between;

    .t_logo {
      width: 20.5rem;
      height: 4.5rem;
    }

    .t_logo02 {
      background: url(~@/assets/images/logo02.png) no-repeat center center;
      background-size: cover;
    }

    .t_logo03 {
      background: url(~@/assets/images/logo03.png) no-repeat center center;
      background-size: cover;
    }

    .t_placeholder {
      height: 4.5rem;
      display: flex;
      align-items: center;

      span {
        cursor: pointer;
      }

      .t_icon {
        cursor: pointer;
        width: 2.8rem;
        height: 2.8rem;
        display: inline-block;
        // margin-left: 3.4rem;
      }

      .t_menu {
        height: 2.6rem;
        margin: 0 3.5rem;
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        .t_menuitem {
          width: 2.8rem;
          height: 0.3rem;
          background: #fff;
        }

        .t_menuitem2 {
          // margin: calc((100% - 5..7rem) / 2) auto;
        }
      }

      .t_menu_blue {
        .t_menuitem {
          background: #013060;
        }
      }

      .t_menu:hover .t_menuitem2 {
        transform: translateX(-50%);
      }

      .t_icon_menu {
        background: url(~@/assets/images/icon_menu.png) no-repeat center center;
        background-size: cover;
      }

      .t_icon_menu02 {
        background: url(~@/assets/images/icon_menu02.png) no-repeat center center;
        background-size: cover;
      }

      .t_icon_search01 {
        background: url(~@/assets/images/icon_search01.png) no-repeat center center;
        background-size: 100% 100%;
      }

      .t_icon_search02 {
        background: url(~@/assets/images/icon_search02.png) no-repeat center center;
        background-size: 100% 100%;
      }
    }

    .t_right {
      font-size: 2rem;
      font-family: Microsoft YaHei UI;
      font-weight: 400;
      color: #ffffff;
      line-height: 4.1rem;
      display: flex;
      align-items: center;

      span {
        cursor: pointer;
      }

      .t_icon {
        cursor: pointer;
        width: 2.8rem;
        height: 2.8rem;
        display: inline-block;
        margin-left: 3.5rem;
      }

      .t_menu {
        height: 2.6rem;
        margin-left: 4.3rem;
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        .t_menuitem {
          width: 2.8rem;
          height: 0.3rem;
          background: #fff;
        }

        .t_menuitem2 {
          // margin: calc((100% - 5.7rem) / 2) auto;
        }
      }

      .t_menu_blue {
        .t_menuitem {
          background: #013060;
        }
      }

      .t_menu:hover .t_menuitem2 {
        transform: translateX(-50%);
      }

      .t_icon_menu {
        background: url(~@/assets/images/icon_menu.png) no-repeat center center;
        background-size: cover;
      }

      .t_icon_menu02 {
        background: url(~@/assets/images/icon_menu02.png) no-repeat center center;
        background-size: cover;
      }

      .t_icon_search01 {
        background: url(~@/assets/images/icon_search01.png) no-repeat center center;
        background-size: 100% 100%;
      }

      .t_icon_search02 {
        background: url(~@/assets/images/icon_search02.png) no-repeat center center;
        background-size: 100% 100%;
      }
    }

    .t_blue {
      color: #013060 !important;
    }
  }

  .t_text {
    font-size: 6.4rem;
    font-family: JingZhe_XiaoWei;
    font-weight: 400;
    color: #fff;
    line-height: 4rem;
    margin-bottom: 2.6rem;
  }

  .b_iconArea {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;

    .b_iconItem {
      cursor: pointer;
      margin-top: 5.2rem;
      margin-right: 9.5rem;
      // width: calc(100% / 6);
      text-align: center;

      .b_iconItem_icon {
        height: 4.4rem;
        // width: 4.0rem;
        margin: 0 auto;

        img {
          // width: 100%;
          height: 100%;
        }
      }

      .b_iconItem_label {
        width: 12rem;
        white-space: nowrap;
        margin-top: 1.8rem;
        font-size: 1.4rem;
        font-family: SimHei;
        font-weight: 400;
        color: #ffffff;
        line-height: 1.8rem;
      }
    }

    .b_iconItem:nth-child(6n) {
      margin-right: 0;
    }
  }

  .b_btn {
    cursor: pointer;
    margin: 7.6rem auto 0;
    width: 36rem;
    height: 6.2rem;
    // background: rgba(1, 48, 96, 0);
    // border: 0.1rem solid #ffffff;
    text-align: center;
    font-size: 2.2rem;
    font-weight: 400;
    color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: 0.5s;

    >div {
      display: inline-block;

      .line {
        width: 0;
        height: 0.1rem;
        background: #fff;
        transition: 0.5s;
      }
    }
  }

  .b_btn:hover {

    // background: #fff;
    .line {
      width: 100%;
    }
  }

  @media screen and (min-width: 1920px) {
    padding: 192px calc((100% - 1400px) / 2) 150px;

    .t_bar {
      top: 60px;
      padding: 0 80px;

      .t_logo {
        width: 205px;
        height: 45px;
      }

      .t_placeholder {
        height: 45px;

        .t_icon {
          width: 28px;
          height: 28px;
        }

        .t_menu {
          height: 26px;
          margin: 0 35px;

          .t_menuitem {
            width: 28px;
            height: 03px;
          }
        }
      }

      .t_right {
        font-size: 20px;
        line-height: 41px;

        .t_icon {
          width: 28px;
          height: 28px;
          margin-left: 35px;
        }

        .t_menu {
          height: 26px;
          margin-left: 43px;

          .t_menuitem {
            width: 28px;
            height: 03px;
          }
        }
      }
    }

    .t_text {
      font-size: 64px;
      line-height: 40px;
      margin-bottom: 26px;
    }

    .b_iconArea {
      .b_iconItem {
        margin-top: 52px;
        margin-right: 95px;

        .b_iconItem_icon {
          height: 44px;
        }

        .b_iconItem_label {
          width: 120px;
          margin-top: 18px;
          font-size: 14px;
          line-height: 18px;
        }
      }
    }

    .b_btn {
      width: 360px;
      height: 62px;
      font-size: 22px;
    }
  }
}

.active {
  .homePage03Box {
    .t_text {
      animation-name: focus-in-contract-108;
      animation-duration: 1s;
      animation-timing-function: ease-out;
      animation-delay: 0s;
      animation-iteration-count: 1;
      animation-direction: normal;
      animation-fill-mode: none;
    }

    .b_iconArea {
      animation-name: focus-in-contract108;
      animation-duration: 1s;
      animation-timing-function: ease-out;
      animation-delay: 0s;
      animation-iteration-count: 1;
      animation-direction: normal;
      animation-fill-mode: none;
    }

    .b_btn {
      animation-name: focus-in-contract108;
      animation-duration: 1s;
      animation-timing-function: ease-out;
      animation-delay: 0s;
      animation-iteration-count: 1;
      animation-direction: normal;
      animation-fill-mode: none;
    }

    .b_iconItem {
      animation: fade-in-bottom96 3s ease 0s 1 normal none;
    }
  }
}
</style>